import { useEffect, useRef } from 'react';

// The original IELTS autosave remains disabled whenever this adapter is present.
export default function useMiniExerciseAdapter({ session, draftState, onRestore }) {
  const restored = useRef(false);
  const previous = useRef(null);
  const restore = useRef(onRestore);
  restore.current = onRestore;
  useEffect(() => {
    if (!session || restored.current) return;
    restored.current = true;
    previous.current = JSON.stringify(draftState);
    restore.current(session.initialState);
  }, [session, draftState]);
  useEffect(() => {
    if (!session || !restored.current) return;
    const serialized = JSON.stringify(draftState);
    if (serialized === previous.current) return;
    previous.current = serialized;
    session.onChange(draftState);
  }, [session, draftState]);
  return {
    clearDraft: async () => {},
    saveDraft: () => session.onSave(),
    hydrated: true,
    draftId: undefined,
  };
}
